<template>
  <Section background="white">
    <FadeIn>
      <Container>
       
        <div class="mx-auto max-w-3xl lg:text-center" v-if="content.title">
          <h2 class="text-section-title">{{ content.title }}</h2>
        </div>

        <div class="mx-auto max-w-[1080px] sm:max-w-[1080px] mt-12 lg:mt-24 md:grid grid-cols-1 gap-8 sm:gap-4 md:gap-8" :class="`sm:grid-cols-${content.stat.length}`">
          <div v-for="item in content.stat" class="text-center mb-12 md:mb-0 sm:text-left col-span-1">
            <div class="text-center md:text-left text-7xl md:text-6xl lg:text-7xl text-[#5a6ded] font-extrabold">
              {{ item.number }}
            </div>
            <div class="text-center md:text-left text-2xl md:text-3xl font-extrabold mt-2">
              {{ item.subject }}
            </div>
            <div class="text-center md:text-left text-base md:text-base mt-2 sm:mt-0 md:mt-2">
              {{ item.text }}
              <a v-if="item.url" :href="item.url" target="_blank" class="ml-1 relative -top-[1px]" aria-label="Click here to view the source">
                <Icon name="iconoir:link" class="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>

        <div class="mx-auto max-w-[1080px] mt-12 lg:mt-24">
          <div
          v-if="content.subtitle"
          class="font-bold text-xl mg:text-2xl lg:text-3xl" 
          v-interpolation 
          v-html="content.subtitle"
          ></div>
        </div>

      </Container>
    </FadeIn>
  </Section>
</template>

<script setup>
const props = defineProps({
  content: {
    type: Object,
    required: true,
  },
  sectionIndex: {
    type: Number
  }
})
</script>